import { useEffect, useState } from 'react'

interface UseDelayedToggleParams {
  isOpen: boolean
  openingTime?: number
  closingTime?: number
}

export const useDelayedToggle = ({
  isOpen,
  openingTime = 0,
  closingTime = 0,
}: UseDelayedToggleParams): boolean => {
  const [toggle, setToggle] = useState(isOpen)

  useEffect(() => {
    const timeout = setTimeout(
      () => {
        setToggle(isOpen)
      },
      isOpen ? openingTime : closingTime,
    )

    return () => {
      clearTimeout(timeout)
    }
  }, [isOpen, openingTime, closingTime])

  return toggle
}
